import {inject} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {CanDeactivateFn, Router} from "@angular/router";
import {of, switchMap} from "rxjs";
import {isRoughPlanCreation} from "../../pages/rough-planning/rough-planning.routes";
import {AlertAction, GenericAlertComponent} from "../../ui/components/generic-alert/generic-alert.component";

export interface HasUnsaved {
    hasUnsaved: () => boolean
}

export const unsavedPeriodGuard: CanDeactivateFn<HasUnsaved> = (component) => {
    const dialog = inject(MatDialog);
    if (!component.hasUnsaved()) {
        return true;
    }
    const dialogRef = dialog.open(GenericAlertComponent, {
        data: {
            title: {translationKey: "menu-planning.weekly-view.dialogs.unsaved.title"},
            message: {translationKey: "menu-planning.weekly-view.dialogs.unsaved.message"},
            confirmButtonText: {translationKey: "general.button.confirm"},
            cancelButtonText: {translationKey: "general.button.skip"},
        },
    });
    return dialogRef.afterClosed().pipe(
        switchMap((action: AlertAction) => of(action === AlertAction.Confirm))
    );
};

export const unsavedModelGuard: CanDeactivateFn<HasUnsaved> = (component) => {
    const dialog = inject(MatDialog);
    const router = inject(Router);
    if (!component.hasUnsaved()) {
        return true;
    }

    const dialogRef = isRoughPlanCreation(router) ? dialog.open(GenericAlertComponent, {
        data: {
            title: {translationKey: "meal-plan-model.create.dialogs.unsaved.rough-title"},
            message: {translationKey: "meal-plan-model.create.dialogs.unsaved.rough-message"},
            confirmButtonText: {translationKey: "general.button.confirm"},
            cancelButtonText: {translationKey: "general.button.skip"},
        },
    }) :
    dialog.open(GenericAlertComponent, {
        data: {
            title: {translationKey: "meal-plan-model.create.dialogs.unsaved.title"},
            message: {translationKey: "meal-plan-model.create.dialogs.unsaved.message"},
            confirmButtonText: {translationKey: "general.button.confirm"},
            cancelButtonText: {translationKey: "general.button.skip"},
        },
    });
    return dialogRef.afterClosed().pipe(
        switchMap((action: AlertAction) => of(action === AlertAction.Confirm))
    );
};

// Add more guards with different translations here if needed